import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

type Props = {
  children: React.ReactNode;
  redirectLink?: string;
};

function ProtectedRouteAdmin({ children, redirectLink }: Props) {
  const adminToken = useSelector((state: RootState) => state.admin.accessToken);
  const location = useLocation();

  const currentPath = encodeURIComponent(location.pathname + location.search);

  if (!adminToken) {
    return (
      <Navigate
        to={redirectLink ? redirectLink : `/admin/send-otp?redirect=${currentPath}`}
        replace
      />
    );
  }

  return <>{children}</>;
}

export default ProtectedRouteAdmin;
